module.exports = __webpack_public_path__ + "je.2496385fb614891406aa.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/je.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/je.svg
// module chunks = styles